/** @format */

import { PropertyTypes } from 'utils/propertyObjectHelper';

export const buildAddress = ({
  streetAddress,
  municipality,
  country = null,
  city,
  estateType,
  objectAddressObj = {},
  showFullAddress = false
}) => {
  let address = [];

  const addSection = (section) => {
    if (section) {
      address.push(section);
    }
  };

  if (showFullAddress) {
    addSection(streetAddress);
    addSection(city);
    addSection(municipality);

    if (estateType === PropertyTypes.ForeignProperty) {
      addSection(country);
    }
  } else {
    addSection(streetAddress);
  }

  if (address.length === 0 && Object.keys(objectAddressObj).length > 0) {
    if (showFullAddress) {
      addSection(objectAddressObj?.streetAddress);
      addSection(objectAddressObj?.city);
      addSection(objectAddressObj?.municipality);
      if (estateType === PropertyTypes.ForeignProperty) {
        addSection(objectAddressObj?.country);
      }
    } else {
      addSection(objectAddressObj?.streetAddress);
    }
  }

  return address.join(', ');
};
